import { Box, Typography, styled, IconButton } from '@mui/material';

export const CompaniesSection = styled(Box)(() => ({
  marginBottom: '20px',
}));

export const CarouselWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '20px 0',
}));

export const ScrollIconButton = styled(IconButton)(() => ({
  border: '1px solid',
  borderColor: '#E5E7EB',
  backgroundColor: '#FFF',
  padding: '4px',
}));

export const CompaniesScrollRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
  overflow: 'hidden',
  scrollBehavior: 'smooth',
  flex: 1,
}));

export const DetailPanel = styled(Box)(() => ({
  background: '#FFF',
  minHeight: '400px',
  borderRadius: '8px',
  padding: '40px',
  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
  overflow: 'auto',
}));

export const DetailEmptyState = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '320px',
}));

export const SectionLabel = styled(Typography)(() => ({
  fontWeight: 600,
  marginBottom: '8px',
}));

export const SectionDescription = styled(Typography)(() => ({
  fontSize: '12px',
  fontWeight: 500,
  color: '#707070',
}));
